module.exports = __webpack_public_path__ + "static/img/u70046.10586208.png";